import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { ACCESS_DENIED_PATH, canAccessPath } from '../role-based-access-control';

interface RoleRouteProps {
  path: string;
  children: React.ReactNode;
}

export default function RoleRoute({ path, children }: RoleRouteProps) {
  const { realmRoles } = useAuth();
  const location = useLocation();

  if (!canAccessPath(realmRoles, path)) {
    return (
      <Navigate
        to={ACCESS_DENIED_PATH}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
}
